<template>
  <div
    v-if="showNotification || showReportWarning"
    class="notification-wrapper"
  >
    <Notification
      type="warning"
      title="You can not get a report because your dashboard does not have data yet."
      v-if="showReportWarning"
    >
      Your dashboard does not have data because this service is for APNIC
      Members that hold at least one ASN (Autonomous System Number).
    </Notification>
    <Notification type="info" :title="text.summary" v-else>
      {{ text.content }}
    </Notification>
  </div>
</template>

<script>
import mixin from '../../utils/mixin';
import Notification from '../ui/Notification';
const TEXTS = {
  noAccount: {
    summary: 'Your dashboard does not have data yet.',
    content:
      'This service is for APNIC Members that hold at least one ASN (Autonomous System Number).'
  },
  noASN: {
    summary: 'No ASN has been assigned to your member account.',
    content:
      'This service is for APNIC Members that hold at least one ASN (Autonomous System Number).'
  },
  noData: {
    summary: 'It seems that your AS is not sending suspicious traffic.',
    content:
      'Our honeynet sensors have not seen any suspicious traffic coming from your AS for the selected time frame. '
  }
};
export default {
  mixins: [mixin],
  data() {
    return {
      showContent: true,

      text: {
        summary: '',
        content: ''
      }
    };
  },
  computed: {
    showNotification() {
      if (this.noAccount) {
        this.text = TEXTS.noAccount;
      } else if (this.noASN) {
        this.text = TEXTS.noASN;
      } else {
        this.text = TEXTS.noData;
      }

      return this.dataReady && (this.noAccount || this.noData || this.noASN);
    }
  },
  components: {
    Notification
  }
};
</script>

<style lang="scss" scoped>
.notification-old {
  display: inline-block;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
  width: 400px;

  @media screen and (max-width: 425px) {
    width: 300px;
  }
  .notification {
    &__summary {
      display: flex;
      align-items: center;
      min-height: 2.5rem;
      font-weight: bold;
      background-color: #e6e6e6;
      padding: 0.5rem 1rem;

      i:first-child,
      svg:first-child {
        margin-right: 10px;
      }
      svg:last-child {
        margin-left: auto;
        text-align: right;
        cursor: pointer;
      }

      .info-circle {
        background: white;
        color: #8a4e94;
        height: 18px;
        min-width: 18px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &__content {
      padding: 0.5rem 1rem;
      background: white;
    }
  }
}
</style>
